import { motion } from "framer-motion";
import { STORY_IMAGE, PROCESS } from "../data/content";
import useSiteContent from "../hooks/useSiteContent";

export const Story = () => {
  const cms = useSiteContent();
  const s = cms.story || {};
  return (
    <section data-testid="story-section" className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-7"
        >
          <div className="img-hover-zoom aspect-[3/2]">
            <img
              src={STORY_IMAGE}
              alt="Severina Gomes, hairstylist da INN.PACT, a realizar um serviço de cabelo profissional numa cliente"
              className="w-full h-full object-cover object-center"
              loading="lazy"
              decoding="async"
            />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <p className="label-editorial text-clay mb-6">{s.kicker || "A nossa essência"}</p>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-tight">
            {s.heading_before || "Um conceito"}{" "}
            <span className="italic text-clay">{s.heading_highlight || "inovador"}</span>
            {s.heading_after || ", sempre um passo à frente."}
          </h2>
          <div className="mt-8 space-y-5 text-black/60 font-light leading-relaxed text-base md:text-lg">
            <p className="whitespace-pre-line">
              {s.paragraph1 || "Nascemos em Leiria com uma convicção simples: a imagem certa não é uma tendência, é a expressão fiel de quem somos. Por isso não começamos pela tesoura, começamos por si."}
            </p>
            <p className="whitespace-pre-line">
              {s.paragraph2 || "Trabalhamos com marcas profissionais de referência e uma metodologia própria de visagismo, para que cada transformação seja coerente com a sua personalidade, os seus objetivos e o seu estilo de vida."}
            </p>
          </div>
        </motion.div>
      </div>

      <div id="metodo" className="max-w-7xl mx-auto px-6 md:px-12 mt-24 md:mt-32">
        <p className="label-editorial text-clay mb-12">O nosso método</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {PROCESS.map((item, i) => (
            <motion.div
              key={item.step}
              data-testid={`process-step-${item.step}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="border-t border-clay/30 pt-6"
            >
              <span className="font-display text-4xl text-clay/40">{item.step}</span>
              <h3 className="font-display text-2xl mt-4 tracking-tight">{item.title}</h3>
              <p className="mt-3 text-sm text-black/55 font-light leading-relaxed">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
